(function() {
  var selectors = {
    requestModal: '#ContactForm',
    requestClose: '.modal__close'
  };

  var requestModal = document.querySelector(selectors.requestModal);
  var requestClose = document.querySelector(selectors.requestClose);

  if (!requestModal) {
    return;
  }

  new window.Modals('ContactForm', 'request-modal');

  //console.log(requestClose);
  requestClose.addEventListener('click', function(e) {
    window.location = '#';
    window.history.replaceState(null, '', window.location.pathname);
  });
})();
